function inputSkin(){

    $('.quantity').append('<div class="clone"><input value="1" type="text" /></div>');

    $(".quantity .clone").append('<div class="inc btn">+</div><div class="dec btn">-</div>');

    $(".quantity .clone .btn").on("click", function() {
        var $btn = $(this);
        var oldValue = $btn.parent().find("input").val();
        if ($btn.text() == "+") {
            var newVal = parseFloat(oldValue) + 1;
        } 
        else {
            if (oldValue > 0) { var newVal = parseFloat(oldValue) - 1; } 
            else { newVal = 0; }
        }
        $btn.parent().find("input").val(newVal);
        $("#quantity").val(newVal);
    });

};